import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

/** Public result page: success after selection, or `?error=<code>` from the OAuth callback. */
const ConnectorDonePage = lazy(
  () => import('~/features/connector-share/pages/connector-done-page'),
);

const searchSchema = z.object({
  error: z.string().optional(),
  connected: z.number().int().nonnegative().optional(),
});

export const Route = createFileRoute('/connector/$token/done')({
  validateSearch: searchSchema,
  component: () => (
    <Suspense fallback={null}>
      <ConnectorDonePage />
    </Suspense>
  ),
});
